import { ComponentStyleConfig } from '@cloudbeds/payment-sdk';

export const FormLabel: ComponentStyleConfig = {
  baseStyle: {
    color: 'black.500',
    mb: 0,
    p: 0,
    fontSize: '14px',
    fontWeight: 600,
    _invalid: {
      color: 'error.500',
    },
  },
};
